import { SubmissionEmailLabel } from 'enums';

export const defaultEmailLabelsSelection = Object.values(SubmissionEmailLabel);
